import { Text } from "@merge-api/merge-javascript-shared";
import { AlertTriangle, Check } from "lucide-react";
import { snakeCaseToSpacedCapitalized } from "../../../services";

type Props = {
  title: string;
  isError?: boolean;
};

const ValidationHeader = ({ title, isError }: Props) => {
  return (
    <>
      <div className="flex flex-row items-center gap-2">
        {isError ? <AlertTriangle size={16} /> : <Check size={16} />}
        <Text variant="md">{snakeCaseToSpacedCapitalized(title)}</Text>
      </div>
    </>
  );
};

export default ValidationHeader;
